import { useContext } from "react";
import { NavContext } from "../Nav/NavContext";
import { i18nContext } from "./i18nContext";

export function useTranslations() {
  const [{ lang }] = useContext(NavContext);
  const [t] = useContext(i18nContext);
  return { t, lang };
}
